var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4066 28.5354C10.5593 28.5354 7.28326 27.1831 4.57855 24.4784C1.87384 21.7737 0.521484 18.4976 0.521484 14.6503C0.521484 10.8029 1.87384 7.52692 4.57855 4.8222C7.28326 2.11749 10.5593 0.765137 14.4066 0.765137C16.8655 0.765137 19.0206 1.26413 20.8719 2.26213C22.7233 3.26012 24.3287 4.62694 25.6883 6.36259V0.765137H28.2918V11.7865H17.2704V9.18301H24.5602C23.4609 7.44737 22.0579 6.04439 20.3512 4.97407C18.6445 3.90376 16.663 3.3686 14.4066 3.3686C11.2535 3.3686 8.585 4.46061 6.40098 6.64463C4.21696 8.82865 3.12495 11.4972 3.12495 14.6503C3.12495 17.8034 4.21696 20.4719 6.40098 22.6559C8.585 24.84 11.2535 25.932 14.4066 25.932C16.8076 25.932 19.0061 25.2449 21.0021 23.8709C22.9981 22.4968 24.3866 20.6816 25.1676 18.4253H27.8579C27.019 21.4627 25.3557 23.9071 22.8679 25.7584C20.3801 27.6098 17.5597 28.5354 14.4066 28.5354Z",
    fill: "#BA4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.299deabbe73a6252b7030cd7b963d168.svg";
export { ForwardRef as ReactComponent };